import React, { useContext, useEffect, useState } from 'react';

const Context = React.createContext(null);

export function DuplicatorRoot({ children }) {
	const state = useState({});
	return <Context.Provider value={state} children={children} />;
}

export function Duplicator({ children, id }) {
	const context = useContext(Context);
	useEffect(() => {
		if(context && id) {
			const [, set] = context;
			set(prev => ({ ...prev, [id]: children }));
		}
	}, [id, children]);
	return <>{children}</>;
}

export function Duplicate({ id }) {
	const context = useContext(Context);
	return context?.[0]?.[id] ?? null;
}
